import { CustomNumberField } from "components/shared/form";
import { truckNumber } from "helpers/validators";
import React from "react";

const Markup = ({
    renderField,
    renderSelect,
    Button,
    counterpartyIds,
    number,
    typeId,
    brandTypeId,
    data = {},
    setCustomNumberMode,
}) => {
    const useCustomNumber = !!data.useCustomNumber;

    return (
        <div>
            {renderSelect(counterpartyIds)}
            <CustomNumberField
                number={number}
                numberValidator={truckNumber}
                onCustomNumberChange={setCustomNumberMode}
                renderField={renderField}
                useCustomNumber={useCustomNumber}
            />
            {renderSelect(typeId)}
            {renderSelect(brandTypeId)}
            {!!Button && <Button />}
        </div>
    );
};

export default Markup;
